import { useContext, useEffect, useState } from "react";
import { Tab, Tabs } from "react-bootstrap";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import {
  GoogleMap,
  Marker,
  withGoogleMap,
  withScriptjs,
} from "react-google-maps";
import { Helmet } from "react-helmet-async";
import PhoneInput from "react-phone-input-2";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { Store } from "../Store";
import OtpValidationModal from "../components/OtpValidationModal";
import useAxios from "../hooks/useAxios";
import {
  businessTypes,
  capitalize,
  diffDateMessage,
  getError,
  getMembershipLabel,
  loginHandler,
  validatePassword,
} from "../utils";
import MembershipSection from "./MembershipSection";

const MapWithAMarker = withScriptjs(
  withGoogleMap((props) => {
    return (
      <GoogleMap
        defaultZoom={15}
        defaultCenter={
          !props.gerror
            ? {
                lat: props.lat,
                lng: props.lng,
              }
            : { lat: 41.015137, lng: 28.97953 }
        }
      >
        <Marker
          position={
            !props.gerror
              ? {
                  lat: props.lat,
                  lng: props.lng,
                }
              : { lat: 41.015137, lng: 28.97953 }
          }
          key={1}
        ></Marker>
      </GoogleMap>
    );
  })
);

export default function AccountProfileScreen() {
  const Axios = useAxios();
  const navigate = useNavigate();
  const { search } = useLocation();
  const sp = new URLSearchParams(search);
  const redirectInUrl = sp.get("redirect");
  const redirect = redirectInUrl ? redirectInUrl : "/";
  const [passwordStrength, setPasswordStrength] = useState("");

  const [name, setName] = useState("");
  const [businessName, setBusinessName] = useState("");
  const [businessType, setBusinessType] = useState("");
  const [showOtpValidation, setShowOtpValidation] = useState(false);
  const [phoneAlreadyInUse, setPhoneAlreadyInUse] = useState(false);
  const [otpValidatingStatus, setOtpValidatingStatus] = useState(false);
  const [customerOtp, setCustomerOtp] = useState("");
  const [password, setPassword] = useState("");
  const [phone, setPhone] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [formValidated, setFormValidated] = useState(false);
  const [phoneValid, setPhoneValid] = useState(true);
  const [activeTab, setActiveTab] = useState(sp.get("active") || "account");
  const [goldPayment, setGoldPayment] = useState(false);
  const [paymentLink, setPaymentLink] = useState("");
  const [paymentToken, setPaymentToken] = useState("");
  const [membership, setMembership] = useState({});
  const [email, setEmail] = useState("");
  const [isPhoneChange, setIsPhoneChange] = useState(false);
  const [isEmailChange, setIsEmailChange] = useState(false);
  const [isPasswordChange, setIsPasswordChange] = useState(false);
  const [isLocationChange, setIsLocationChange] = useState(false);
  const [lat, setLat] = useState(null);
  const [lng, setLng] = useState(null);
  const [gerror, setGerror] = useState(false);

  const { state, dispatch: ctxDispatch } = useContext(Store);
  const { userInfo } = state;
  const [showMap, setShowMap] = useState(true);

  const submitHandler = async (e) => {
    e.preventDefault();
    const form = e.currentTarget;
    if (form.checkValidity() === false) {
      setFormValidated(true);

      if (isPhoneChange && phone.length !== 12) {
        setPhoneValid(false);
      }
      return;
    }

    if (isPasswordChange && passwordStrength !== "Şifre güçlü") {
      toast.error("Lütfen daha güçlü bir şifre oluşturunuz!");
      return;
    }

    if (isPhoneChange && phone.length !== 12) {
      setPhoneValid(false);
      return;
    }

    if (isPasswordChange && password !== confirmPassword) {
      toast.error("Şifre tekrarı hatalı");
      return;
    }

    if (isPhoneChange) {
      try {
        const { data } = await Axios.get(
          `/api/busers/checkphone/${"+" + phone}`
        );
        if (data.phoneInUse) {
          toast.error(
            "Girdiğiniz telefon numarası başka bir hesapta kullanılmış, lütfen başka bir telefon numarası ile kayıt yapınız"
          );
          return;
        }
      } catch (err) {
        return;
      }
    }

    if (isEmailChange && email !== userInfo.email) {
      console.log(email);
      console.log(userInfo.email);
      try {
        const { data } = await Axios.get(`/api/busers/checkemail/${email}`);
        if (data.emailInUse) {
          toast.error(
            "Girdiğiniz e-posta adresi başka bir hesapta kullanılmış, lütfen başka bir e-posta ile kayıt yapınız"
          );
          return;
        }
      } catch (err) {
        return;
      }
    }

    if (
      (isEmailChange && email !== userInfo.email) ||
      isPhoneChange ||
      isPasswordChange ||
      (!gerror && isLocationChange)
    ) {
      try {
        await Axios.post("/api/email/send-otp/hesap-bilgileri-guncelle", {
          to: email,
          name: name,
        });
        setShowOtpValidation(true);
      } catch (err) {
        toast.error("Doğrulama E-postası gönderilemedi");
        return;
      }
      return;
    } else {
      try {
        const { data } = await Axios.put(
          `/api/busers/business/${userInfo._id}`,
          {
            name,
            businessName,
            businessType,
          }
        );
        loginHandler(data, ctxDispatch, localStorage);
        toast.info("Hesap bilgileriniz güncellendi");
        setIsEmailChange(false);
        setIsLocationChange(false);
        setIsPasswordChange(false);
        setIsPhoneChange(false);
      } catch (err) {
        toast.error(getError(err));
      }
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const { data } = await Axios.get(
          `/api/busers/business/${userInfo._id}`
        );
        setName(data.name);
        setBusinessName(data.businessName);
        setBusinessType(data.businessType);
        setPhone(data.phone ? data.phone.replace("+", "") : "");
        setEmail(data.email);
        setPassword("");
        console.log(data);
        setMembership(data.membership);

        if (
          !data.membership ||
          new Date(data.membership.endDate) <= new Date() ||
          data.membership.name === "3-FREE-MONTHS" ||
          data.membership.name === "1-FREE-MONTH"
        ) {
          setGoldPayment(true);
          const { data: dataPaymentLink } = await Axios.get(`/api/payment`);
          setPaymentLink(dataPaymentLink.pageUrl);
          setPaymentToken(dataPaymentLink.token);
        }
      } catch (err) {}
    };
    fetchData();
  }, [userInfo]);

  const handleKayitFinish = async () => {
    try {
      const phoneChange = isPhoneChange ? { phone: "+" + phone } : {};
      const emailChange = isEmailChange ? { email } : {};
      const passChange = isPasswordChange ? { password } : {};
      const latitudeChange =
        isLocationChange && !gerror ? { latitude: lat } : {};
      const longitudeChange =
        isLocationChange && !gerror ? { longitude: lng } : {};

      const { data } = await Axios.put(`/api/busers/business/${userInfo._id}`, {
        name,
        ...phoneChange,
        ...passChange,
        ...emailChange,
        businessName,
        businessType,
        ...latitudeChange,
        ...longitudeChange,
      });
      loginHandler(data, ctxDispatch, localStorage);
      toast.info("Hesap bilgileriniz güncellendi");
      setIsPasswordChange(false);
      setIsPhoneChange(false);
      setIsLocationChange(false);
    } catch (err) {
      toast.error(getError(err));
    }
  };

  const handleValidateOtp = async (kod) => {
    try {
      const { data } = await Axios.post("/api/email/verify-otp", {
        to: email,
        otp: kod,
      });

      setShowOtpValidation(false);
      handleKayitFinish();
      setCustomerOtp("");
      setOtpValidatingStatus(false);
    } catch (err) {
      setOtpValidatingStatus(false);
      toast.error(getError(err));
    }
  };

  const getGeoPosition = () => {
    navigator.geolocation.getCurrentPosition(
      (p) => {
        setLat(p.coords.latitude);
        setLng(p.coords.longitude);
        setIsLocationChange(true);
      },
      (e) => {
        setGerror(true);

        navigator.permissions.query({ name: "geolocation" }).then((result) => {
          if (result.state === "granted") {
            setIsLocationChange(true);
            window.alert(
              "Konum servisiniz kapalı! Lütfen öncelikle cihaz ayarlarından konum servisini açınız!"
            );
          } else if (result.state === "prompt") {
            setIsLocationChange(true);
          } else if (result.state === "denied") {
            window.alert(
              "Uygulamanın konum servisine erişimi kısıtlandı! Bu işlemi gerçekleştiremezsiniz!"
            );
          }
        });
      }
    );
  };

  function delay(time) {
    return new Promise((resolve) => setTimeout(resolve, time));
  }

  return (
    <div className="small-container">
      <Helmet>
        <title>Kullanıcı Hesap Bilgileri</title>
      </Helmet>
      <h1 className="my-3 text-muted">Hesap Bilgilerim</h1>

      <Tabs
        activeKey={activeTab}
        onSelect={(k) => setActiveTab(k)}
        className="mb-3"
      >
        <Tab
          eventKey="account"
          title={
            <span>
              <i className="fas fa-user" /> &nbsp;Hesabım
            </span>
          }
        >
          <Form onSubmit={submitHandler} noValidate validated={formValidated}>
            <Form.Group className="mb-3">
              <Form.Label>Adınız</Form.Label>
              <Form.Control
                className="signup-form-control"
                onChange={(e) => {
                  setName(capitalize(e.target.value));
                }}
                required
                autoFocus
                value={name}
              />
              <Form.Control.Feedback type="invalid">
                Lütfen ad alanini boş bırakmayınız
              </Form.Control.Feedback>
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>İşletme Adı</Form.Label>
              <Form.Control
                className="signup-form-control"
                onChange={(e) => setBusinessName(e.target.value)}
                required
                autoFocus
                value={businessName}
              />
              <Form.Control.Feedback type="invalid">
                Lütfen işletme adı alanini boş bırakmayınız
              </Form.Control.Feedback>
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>İşletme Tipi</Form.Label>
              <Form.Select
                className="signup-form-control"
                value={businessType}
                onChange={(e) => {
                  setBusinessType(e.target.value);
                }}
              >
                {businessTypes.map((c) => (
                  <option value={c.type} key={c.type}>
                    {c.name}
                  </option>
                ))}
              </Form.Select>
              <Form.Control.Feedback type="invalid">
                Lütfen işletme tipi alanını boş bırakmayınız
              </Form.Control.Feedback>
            </Form.Group>

            <Form.Group className="mb-3">
              {isEmailChange ? (
                <>
                  <Form.Label>
                    E-posta Adresiniz{" "}
                    <Link to="" onClick={() => setIsEmailChange(false)}>
                      Vazgeç
                    </Link>
                  </Form.Label>
                  <Form.Control
                    className="signup-form-control"
                    type="email"
                    required
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    pattern="^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$"
                  />
                  <Form.Control.Feedback type="invalid">
                    Lütfen geçerli bir e-posta adresi giriniz
                  </Form.Control.Feedback>
                </>
              ) : (
                <div>
                  <Link
                    to=""
                    className="textDecorationNone"
                    onClick={() => setIsEmailChange(true)}
                  >
                    <span>{email ? email : "E-postanızı "}</span> Değiştirmek
                    için{" "}
                    <span style={{ textDecoration: "underline" }}>
                      tıklayınız
                    </span>
                  </Link>
                </div>
              )}
            </Form.Group>

            <Form.Group className="mb-3">
              {isPhoneChange ? (
                <>
                  <Form.Label>
                    Telefon Numaranız{" "}
                    <Link to="" onClick={() => setIsPhoneChange(false)}>
                      Vazgeç
                    </Link>
                  </Form.Label>
                  <PhoneInput
                    country={"tr"}
                    onlyCountries={["tr"]}
                    countryCodeEditable={false}
                    value={phone}
                    autoFocus
                    onChange={(p) => {
                      setPhone(p);
                      setPhoneValid(true);
                      setPhoneAlreadyInUse(false);
                    }}
                    inputClass="signup-form-control  signup-phone-input form-control"
                    inputStyle={{ width: "100%", height: "48px" }}
                    buttonStyle={{
                      borderTopLeftRadius: "10px",
                      borderBottomLeftRadius: "10px",
                    }}
                    inputProps={{
                      name: "Telefon",
                    }}
                    isValid={(value, country) => {
                      if (!phoneValid) {
                        return "Telefon numarasını hatalı girdiniz";
                      }
                      return true;
                    }}
                  />
                </>
              ) : (
                <Link
                  to=""
                  className="textDecorationNone"
                  onClick={() => setIsPhoneChange(true)}
                >
                  <span>{phone ? " +" + phone : "Telefon Numaranızı "}</span>{" "}
                  Değiştirmek için{" "}
                  <span style={{ textDecoration: "underline" }}>
                    tıklayınız
                  </span>
                </Link>
              )}
            </Form.Group>

            {isPasswordChange ? (
              <>
                <Form.Group className="mb-3">
                  <Form.Label>
                    Şifre &nbsp;
                    {isPasswordChange && (
                      <Link to="" onClick={() => setIsPasswordChange(false)}>
                        Vazgeç
                      </Link>
                    )}
                  </Form.Label>
                  <Form.Control
                    className="signup-form-control"
                    type="password"
                    required
                    value={password}
                    onChange={(e) => {
                      const newPassword = e.target.value;
                      setPassword(newPassword);
                      validatePassword(newPassword, setPasswordStrength);
                    }}
                  />
                  <small
                    id="passwordHelpBlock"
                    className={`signup-form-text ${
                      passwordStrength === "Şifre güçlü"
                        ? "text-success"
                        : "text-danger"
                    }`}
                  >
                    {passwordStrength}
                  </small>
                  <Form.Control.Feedback type="invalid"></Form.Control.Feedback>
                </Form.Group>

                <Form.Group className="mb-3">
                  <Form.Label>Şifrenizi Tekrar Ediniz</Form.Label>
                  <Form.Control
                    className="signup-form-control"
                    type="password"
                    onChange={(e) => setConfirmPassword(e.target.value)}
                    value={confirmPassword}
                    required
                  />
                  <Form.Control.Feedback type="invalid">
                    Lütfen şifre alanini boş bırakmayınız
                  </Form.Control.Feedback>
                </Form.Group>
              </>
            ) : (
              <div className="mb-3">
                <Link
                  to=""
                  className="textDecorationNone"
                  onClick={() => setIsPasswordChange(true)}
                >
                  Şifrenizi değiştirmek için{" "}
                  <span style={{ textDecoration: "underline" }}>
                    tıklayınız
                  </span>
                </Link>
              </div>
            )}

            {isLocationChange ? (
              !gerror ? (
                <Form.Group className="mb-3">
                  <Form.Label>
                    İşletmenin Konumu &nbsp;
                    <Link to="" onClick={() => setIsLocationChange(false)}>
                      Vazgeç
                    </Link>
                  </Form.Label>
                  <div>
                    <Form.Label>
                      Harita açılmadı ise
                      <Link
                        to=""
                        onClick={async () => {
                          setShowMap(false);
                          await delay(200);
                          setShowMap(true);
                          getGeoPosition();
                        }}
                        variant="link"
                        className="text-primary"
                      >
                        {" "}
                        tekrar deneyiniz &nbsp;
                        <i className="fas fa-refresh"></i>
                      </Link>
                    </Form.Label>
                  </div>
                  {!gerror && (
                    <div>
                      <small className="form-text text-muted">
                        Konum hizmetinden alınan mevcut konumunuz işletmenin
                        konumu olarak ayarlanacaktır!
                      </small>
                    </div>
                  )}

                  {showMap && (
                    <MapWithAMarker
                      lat={lat}
                      lng={lng}
                      googleMapURL="https://maps.googleapis.com/maps/api/js?key=AIzaSyB3BBsivFtnwJ_uEvs-vA_mAzD8Q7Mwsz4&v=3.exp&libraries=geometry,drawing,places"
                      loadingElement={<div style={{ height: `100%` }} />}
                      containerElement={<div style={{ height: `400px` }} />}
                      mapElement={<div style={{ height: `100%` }} />}
                    />
                  )}
                </Form.Group>
              ) : (
                <div className="mb-3">
                  <span className="text-danger">
                    Konum servisiniz kapalı! Lütfen öncelikle cihaz ayarlarından
                    konum servisini açınız!
                  </span>
                </div>
              )
            ) : (
              <div className="mb-3">
                <Link
                  to=""
                  className="textDecorationNone"
                  onClick={() => {
                    if (
                      !window.confirm(
                        "Lütfen uygulamanın google konum servini kullanmasına izin veriniz!"
                      )
                    ) {
                      return;
                    }
                    if (!navigator.geolocation) {
                      window.alert(
                        "Cihazınız konum servisini desteklememektedir, lüften bu işlemi konum hizmeti çalışan bir cihazdan gerçekleştiriniz!"
                      );
                    } else {
                      getGeoPosition();
                    }
                  }}
                >
                  İşletmenin konumunu güncellemek için{" "}
                  <span style={{ textDecoration: "underline" }}>
                    tıklayınız
                  </span>
                </Link>
              </div>
            )}

            <div className="mb-3">
              <Button
                type="submit"
                variant="light"
                className="border-primary text-primary"
              >
                Bilgilerimi Kaydet
              </Button>{" "}
            </div>
          </Form>
        </Tab>
        <Tab
          eventKey="membership"
          title={
            <span>
              <i className="fas fa-address-card"></i>&nbsp;Üyeliğim
            </span>
          }
        >
          <MembershipSection
            membership={membership}
            goldPayment={goldPayment}
            paymentLink={paymentLink}
            getMembershipLabel={getMembershipLabel}
            diffDateMessage={diffDateMessage}
          />
        </Tab>
      </Tabs>

      <OtpValidationModal
        showOtpValidation={showOtpValidation}
        setShowOtpValidation={setShowOtpValidation}
        handleValidateOtp={handleValidateOtp}
        setCustomerOtp={setCustomerOtp}
        customerOtp={customerOtp}
        setOtpValidatingStatus={setOtpValidatingStatus}
        otpValidatingStatus={otpValidatingStatus}
        email={email}
      />
    </div>
  );
}
